import "./staightPage.css";

export default function SportsEventsSliderSkeleton() {
  return (
    <div
      className="sportsEventsSliderWrapper sportsEventsSliderSkeleton"
      aria-busy="true"
      aria-label="Loading banners"
    >
      <div className="sportsEventsSliderSkeleton__track">
        {[0, 1, 2].map((index) => (
          <div key={index} className="sportsEventsSliderSkeleton__slide" />
        ))}
      </div>
    </div>
  );
}
